export const isOdd = (num: number) => {
  return num % 2 !== 0;
};

export const isEven = (num: number) => {
  return num % 2 === 0;
};
